import type { NavigationLink } from './types';

export const NAVBAR_HEIGHT = 70;
export const NAVBAR_ANIMATION_DURATION = 500;
export const MOBILE_MENU_TOP_OFFSET = 80;

export const NAVIGATION_LINKS: NavigationLink[] = [
  { href: '/about', label: 'About Us' },
  { href: '/posts', label: 'Blog & News' },
];
